// src/config/modules.js
import React from 'react';
import {
    CalendarIcon,
    WrenchScrewdriverIcon,
    DocumentTextIcon,
    ClipboardDocumentListIcon,
    UserGroupIcon,
    TruckIcon,
    CurrencyDollarIcon,
    BanknotesIcon,
    ChartBarIcon,
    CubeIcon,
    EnvelopeIcon,
    Cog6ToothIcon,
    ShieldCheckIcon
} from '@heroicons/react/24/solid';

export const MODULES = [
    {
        id: 'calendar',
        page: 'calendar',
        title: 'Agenda',
        description: 'Calendario de visitas técnicas, coordinación de equipos y creación rápida de clientes.',
        color: 'bg-blue-600',
        icon: <CalendarIcon className="w-6 h-6" />
    },
    {
        id: 'reports',
        page: 'form', // La página de creación de informes
        title: 'Nuevo Informe de Visita',
        description: 'Generar reporte de visita, checklist de mantenimiento y consumo de materiales.',
        color: 'bg-green-600',
        icon: <DocumentTextIcon className="w-6 h-6" />
    },
    {
        id: 'techReports',
        page: 'techReports',
        title: 'Informes Técnicos',
        description: 'Genera informes técnicos profesionales: TE1, imágenes, memorias, periciales y más.',
        color: 'bg-cyan-600',
        icon: <ClipboardDocumentListIcon className="w-6 h-6" />
    },
    {
        id: 'quotes',
        page: 'quotes',
        title: 'Cotizaciones',
        description: 'Crear, enviar y gestionar estados de cotizaciones comerciales.',
        color: 'bg-indigo-600',
        icon: <CurrencyDollarIcon className="w-6 h-6" />
    },
    {
        id: 'accounting',
        page: 'accounting',
        title: 'Cobranza',
        description: 'Seguimiento de facturas, pagos parciales y deudas de clientes.',
        color: 'bg-red-500',
        icon: <BanknotesIcon className="w-6 h-6" />
    },
    {
        id: 'clients',
        page: 'clients',
        title: 'Clientes',
        description: 'Base de datos de clientes, historial de equipos y ubicaciones.',
        color: 'bg-purple-600',
        icon: <UserGroupIcon className="w-6 h-6" />
    },
    {
        id: 'tools',
        page: 'tools',
        title: 'Herramientas Técnicas',
        description: 'Calculadoras de ingeniería: Ley de Ohm, Caída de Tensión, etc.',
        color: 'bg-orange-500',
        icon: <WrenchScrewdriverIcon className="w-6 h-6" />
    },
    {
        id: 'providers',
        page: 'providers',
        title: 'Proveedores',
        description: 'Gestión de proveedores y órdenes de compra.',
        color: 'bg-teal-600',
        icon: <TruckIcon className="w-6 h-6" />
    },
    {
        id: 'products',
        page: 'products',
        title: 'Inventario',
        description: 'Control de stock, productos y materiales.',
        color: 'bg-amber-600',
        icon: <CubeIcon className="w-6 h-6" />
    },
    {
        id: 'finance',
        page: 'finance',
        title: 'Gastos y Finanzas',
        description: 'Registro de gastos operativos y flujo de caja.',
        color: 'bg-rose-600',
        icon: <ChartBarIcon className="w-6 h-6" />
    },
    {
        id: 'mail',
        page: 'mail',
        title: 'Correos',
        description: 'Logs de correos enviados y plantillas.',
        color: 'bg-gray-600',
        icon: <EnvelopeIcon className="w-6 h-6" />
    },
    {
        id: 'users', // id 'users' coincide con permisos 'users'
        page: 'hr',
        title: 'Personal (RRHH)',
        description: 'Gestión de usuarios, roles y permisos de acceso.',
        color: 'bg-cyan-600',
        icon: <ShieldCheckIcon className="w-6 h-6" />
    },
    {
        id: 'parameters',
        page: 'parameters',
        title: 'Configuración',
        description: 'Ajustes generales del sistema y marca blanca.',
        color: 'bg-slate-700',
        icon: <Cog6ToothIcon className="w-6 h-6" />
    },
    {
        id: 'superadmin',
        page: 'superadmin',
        title: 'Super Admin',
        description: 'Configuración maestra del sistema SaaS.',
        color: 'bg-black',
        icon: <ShieldCheckIcon className="w-6 h-6" />
    }
];